<script lang="ts">
  import type { Feedback } from "@/stores/dashboard";

  const { feedback, onClose }: { feedback: Feedback; onClose: () => void } = $props();

  let hovered = $state(false);
  let focused = $state(false);

  $effect(() => {
    const notice = feedback;
    if (hovered || focused) {
      return;
    }
    const timer = window.setTimeout(onClose, notice.kind === "error" ? 8000 : 5000);
    return () => window.clearTimeout(timer);
  });
</script>

<div
  class={`feedback ${feedback.kind}`}
  role={feedback.kind === "error" ? "alert" : "status"}
  aria-atomic="true"
  onmouseenter={() => (hovered = true)}
  onmouseleave={() => (hovered = false)}
  onfocusin={() => (focused = true)}
  onfocusout={() => (focused = false)}
>
  <span class="feedback-icon" aria-hidden="true">{feedback.kind === "error" ? "!" : "✓"}</span>
  <span class="feedback-text">{feedback.text}</span>
  <button type="button" onclick={onClose} aria-label="Закрыть">×</button>
</div>

<style>
  .feedback {
    position: fixed;
    z-index: 90;
    top: calc(5rem + env(safe-area-inset-top, 0px));
    right: max(1rem, env(safe-area-inset-right, 0px));
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    width: min(25rem, calc(100vw - 2rem));
    max-height: calc(100dvh - 7rem);
    overflow-y: auto;
    padding: 1rem;
    border: 1px solid var(--line);
    border-left: 3px solid currentColor;
    background: var(--surface);
    box-shadow: 0 12px 36px rgb(0 0 0 / 0.3);
    font-size: 0.82rem;
    animation: appear 180ms ease-out;
  }

  .feedback.success {
    color: var(--green);
  }

  .feedback.error {
    color: var(--mars-light);
  }

  .feedback-icon {
    display: grid;
    place-items: center;
    flex: 0 0 1.5rem;
    height: 1.5rem;
    border: 1px solid currentColor;
    border-radius: 50%;
    font-weight: 700;
  }

  .feedback-text {
    flex: 1;
    min-width: 0;
    padding-top: 0.15rem;
    color: var(--cream);
    overflow-wrap: anywhere;
  }

  button {
    flex: 0 0 1.75rem;
    min-height: 1.75rem;
    padding: 0;
    border: 0;
    color: inherit;
    background: transparent;
    font-size: 1.4rem;
    line-height: 1;
  }

  button:hover {
    background: rgb(255 255 255 / 0.06);
  }

  @keyframes appear {
    from {
      opacity: 0;
      transform: translateY(-0.5rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .feedback {
      animation: none;
    }
  }
</style>
